import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import Axios from 'axios';
import Page from '../../Common/Page';
import ProgressIndicator from '../../Common/ProgressIndicator';
import ErrorIndicator from '../../Common/ErrorIndicator';

function NewsDetailPage() {
    const { url } = useParams();  // <-- ID alapján
    const [news, setNews] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(false);

    useEffect(() => {
        setIsLoading(true);
        Axios.get(`/news/${url}`)
            .then(res => {
                setNews(res);
                console.log(res);
                setIsLoading(false);
            })
            .catch(() => {
                setError(true);
                setIsLoading(false);
            });
    }, [url]);

    if (isLoading) return <ProgressIndicator />;
    if (error) return <ErrorIndicator text="A hír letöltése sikertelen." />;
    if (!news) return null;

    return (
        <Page>
            <h1>{news.title}</h1>
            <div dangerouslySetInnerHTML={{ __html: news.content }} />
        </Page>
    );
}

export default NewsDetailPage;
